import ApiService from "./api.service";

const InventoryService = {
	store: (data) => {
		return ApiService.post(`inventory/start`, data).then(response => response.data);
	},
	list: (data) => {
		return ApiService.post('inventory/list', data).then(response => response.data);
	},
	finish(id) {
		return ApiService.post(`inventory/finish/${id}`).then(response => response.data);
	},
	saveInventoryForVozvrat(data) {
		return ApiService.post(`/inventory/return/${data.count}/${data.item.itemId}/${data.inventoryId}`, data);
	},
	saveInventoryForBoynigaQoyish(data) {
		return ApiService.post(`/inventory/adjustment`, data);
	},
	saveInventorList(data) {
		return ApiService.post(`/inventory/save/${data.inventoryId}`, data.inventoryList);
	},
	saveSpisatService(data) {
		return ApiService.post(`/inventory/spisat/${data.count}/${data.item.itemId}/${data.inventoryId}`,data);
	},
	getInventryByIdService(inventoryId) {
		return ApiService.get(`/inventory/get-inventory-by-id/${inventoryId}`);
	},
	getInventryItemsByIdService(inventoryId) {
		return ApiService.post(`/inventory/get/${inventoryId}`);
	},
	deleteInventory(inventoryId) {
		return ApiService.delete(`/inventory/delete/${inventoryId}`);
	},

	getListItemWithPrice(depId,data){
		return ApiService.post(`/inventory/list-with-price/${depId}`,data);
	},

	start(data){
		return ApiService.post(`/inventory/start`,data);
	},

	startPartial(data){
		return ApiService.post(`/inventory/start-partial`,data);
	},

	checkAllChildFinish(id){
		return ApiService.get(`/inventory/was-finished/${id}`);
	}

};
export default InventoryService;
